import PropTypes from 'prop-types'
import Link from 'next/link'

const tagName = ({ children, url }) => {
  return (
    url
      ? (
        <Link href={url}>
          <a>
            {children}
          </a>
        </Link>
      )
      : (
        <span></span>
      )
  )
}

tagName.propTypes = {
  children: PropTypes.any
}

export default tagName
